<div class="card-general-container">
    <!--text-->
    <div class="card-text-container ly-sp-s-top ly-sp-s-bottom">
        <div class="bs-h2 th-text-main">{{this.getTitle()}}</div>
        <div class="bs-paragraph th-text-gray-paragraphs card-description-text">{{this.getDescription()}}</div>
    </div>
    <!--divider-->
    <div class="card-divider th-bg-border-line-background"></div>

    <!--clipboard-->
    <!--container of the under part for the clipboard text-->
    <div class="card-clipboard-container" *ngIf="this.getType() === cardType.Clipboard">

    <div class="clipboardValue bs-paragraph th-text-confirmation">{{this.getClipboardValue()}}</div> 
    <!--Icon clipboard-->
    <i class="fa fa-clone fa-lg bold-icon" aria-hidden="true" (click)="copyToClipboard(getClipboardValue())"></i>
    </div>

    <div class="tooltip-container d-flex align-items-center"
        *ngIf="this.isTooltipShown">
      <div class="tooltip-message-window th-bg-confirmation">
        <i class="fa fa-check-circle-o fa-lg" aria-hidden="true"></i>
        <span class="th-text-white bs-paragraph"> ¡Copiado al portapapeles con éxito!</span>
      </div>
    </div>
</div>